export default "__VITE_ASSET__BRSPIERD__"